import { useState } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import capitalize from 'lodash/capitalize'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import TaxonomyPopoverContent from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/List/Line/Form/CompensationTypePopoverMenu/TaxonomyPopoverContent'
import type SupplementForm from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/SupplementForm'

interface Props {
  form: SupplementForm
  options: { label: string; value: string }[]
  onSubmit: () => Promise<unknown>
  readonly: boolean
  size: 'expansive' | 'compact'
  toggleTaxonomyCreationModal: (newState: boolean) => void
  hasError: boolean
}

const CompensationTypePopoverMenu = ({
  form,
  options,
  onSubmit,
  readonly,
  size = 'compact',
  toggleTaxonomyCreationModal,
  hasError,
}: Props) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  function handlePopoverToggle(newPopoverState: boolean) {
    setIsPopoverOpen(newPopoverState)
  }

  const onChangeTaxonomy = (value: string) => {
    form.get('contracts_taxonomy_id').set(value === '0' ? null : value)
    onSubmit()
    setIsPopoverOpen(false)
  }

  const taxonomyName = () => {
    return options?.find((option) => option.value === form.get('contracts_taxonomy_id').value)
      ?.label
  }

  const boxWidth = size === 'compact' ? 's200' : 'full'

  return (
    <PopoverMenu type="list" open={isPopoverOpen} onClick={handlePopoverToggle}>
      <PopoverMenu.Trigger disabled={readonly}>
        <Box
          border={{
            all: { color: hasError ? 'radicalRed1000' : 'grey400', width: 's2', style: 'solid' },
          }}
          borderRadius={{ all: 'abs008' }}
          background={readonly ? 'grey200' : 'grey000White'}
          paddingY="s8"
          paddingX="s16"
          width={boxWidth}
          textAlign="left"
          flexDirection="row"
          justifyContent="spaceBetween"
          alignItems="center"
          aria-label={'select taxonomy'}
          cursor={readonly ? 'default' : 'pointer'}
        >
          <Text.Normal color="grey1000" ellipsis>
            {capitalize(taxonomyName()) || i18n.t('common.select')}
          </Text.Normal>
          <Icon.Small icon="caret-down" />
        </Box>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="center" width="s300">
        <TaxonomyPopoverContent
          options={options}
          form={form}
          onChangeTaxonomy={onChangeTaxonomy}
          setModalOpen={toggleTaxonomyCreationModal}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default observer(CompensationTypePopoverMenu)
